import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import EctropionForm from '#forms/ectropion.js'

@define
export default class EctropionFormStore extends Store {
    @(type(EctropionForm).events({"change": "formchange"}).as) ectropionForm: EctropionForm
}

const store = window.store = new EctropionFormStore({ id: "ectropion" })
export { store };
